import React from "react";
import styles from "./styles.module.css";
import backgroundImage from "../images/Baccarat/tableBg.webp";
import newRoundImg from "../images/Baccarat/New_Round.svg";
import welcome from "../images/Baccarat/welcome.gif";
import ideal from "../images/Baccarat/idle.gif";
import clapping from "../images/Baccarat/clapping.gif";
import crown from "../images/Baccarat/crown.png";
import closedCard from "../images/Baccarat/closed-card.jpg";
import { cards } from "../images/index";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import useRoundLoader from "../../../api/useRoundLoader";
import GameAreaLoader from "../../Loader/GameAreaLoader";

const mapCardStringToAsset = (cardString) => {
  if (!cardString || typeof cardString !== 'string') return closedCard;
  const raw = cardString.trim().toUpperCase().replace(/\.(WEBP|PNG|JPE?G|SVG)$/i, '');
  if (cards[raw]) return cards[raw];
  if (cards[`${raw}.webp`]) return cards[`${raw}.webp`];
  return closedCard;
};

export default function GameScreen({ bettingClosed, socketData }) {
 const roundId = socketData?.roundId;
const settlement = socketData?.settlement;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlement, 5000);

  const stage = !bettingClosed
    ? "welcome"
    : settlement?.clapping
      ? "clapping"
      : "idle";

  const currentGif =
    stage === "welcome" ? welcome : stage === "clapping" ? clapping : ideal;

  const showCards = stage !== "welcome";

  const A3 = showCards ? settlement?.playerACard1 : null;
  const A2 = showCards ? settlement?.playerACard2 : null;
  const A1 = showCards ? settlement?.playerACard3 : null;
  const B1 = showCards ? settlement?.playerBCard1 : null;
  const B2 = showCards ? settlement?.playerBCard2 : null;
  const B3 = showCards ? settlement?.playerBCard3 : null;

  const getWinnerDisplay = (outcome) => {
    if (!outcome) return "Waiting...";
    const upper = outcome.toUpperCase().trim();
    if (upper.includes("PLAYER_A")) return "Player A";
    if (upper.includes("PLAYER_B")) return "Player B";
    if (upper.includes("TIE")) return "Tie";
    return "Tie";
  };

  return (
    <GameAreaLoader showLoader={gameScreenLoader}>
      <div className={styles.baccaratGameContainer}>
        <div className={styles.baccaratMainArea}>
          <div className={styles.baccaratVideoArea}>
            <div className={styles.baccaratVideoContainer}>
              <img
                src={backgroundImage}
                alt="Baccarat Table"
                className={styles.baccaratBackgroundImage}
                draggable={false}
              />

              <div className={styles.baccaratGifOverlay}>
                <img
                  src={currentGif}
                  alt={stage + " gif"}
                  className={styles.baccaratGifImage}
                  draggable={false}
                  style={{ objectFit: "contain", zIndex: 10 }}
                />
              </div>

              <div className={styles.baccaratCardsContainer}>
                <div className={`${styles.baccaratPlayerSection} ${styles.baccaratPlayerASection}`}>
                  <div className={styles.baccaratPlayerCards}>
                    {[A1, A2, A3].map((card, index) => (
                      <img
                        key={`playerA-${index}`}
                        src={card ? mapCardStringToAsset(card) : closedCard}
                        alt={`PlayerA-Card${index + 1}`}
                        className={`${styles.baccaratCardImage} ${index === 0 ? styles.baccaratCardRotateLeft : ""}`}
                        draggable={false}
                      />
                    ))}
                  </div>
                  <span className={styles.baccaratPlayerLabel}>PLAYER A</span>
                </div>

                <div className={styles.baccaratDivider} />

                <div className={`${styles.baccaratPlayerSection} ${styles.baccaratPlayerBSection}`}>
                  <div className={styles.baccaratPlayerCards}>
                    {[B1, B2, B3].map((card, index) => (
                      <img
                        key={`playerB-${index}`}
                        src={card ? mapCardStringToAsset(card) : closedCard}
                        alt={`PlayerB-Card${index + 1}`}
                        className={`${styles.baccaratCardImage} ${index === 2 ? styles.baccaratCardRotateRight : ""}`}
                        draggable={false}
                      />
                    ))}
                  </div>
                  <span className={styles.baccaratPlayerLabel}>PLAYER B</span>
                </div>

                {stage === "clapping" && settlement?.outcome && (
                  <div className={styles.baccaratWinnerAnimation}>
                    <img src={crown} alt="Winner Crown" className={styles.baccaratCrownImage} />
                    <span className={styles.baccaratWinnerText}>
                      Winner: {getWinnerDisplay(settlement.outcome)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {processingLoader && (
  <div className="dataProcessingOverlay">
    <div className="cardSpinner" />
  </div>
)}
      </div>
    </GameAreaLoader>
  );
}